import App from './App.vue'
import store from './store'

const isMobile = store.getters['device/isMobile']
const PCLogin = resolve => require(['./views/login/index'], resolve)
const MobileLogin = resolve => require(['./views/mobile/login/index'], resolve)
const Login = isMobile ? MobileLogin : PCLogin
// const World = resolve => require(['./views/world/index'], resolve)
const SceneHamengdaier = resolve => require(['./views/scene/haMengDaiEr/index'], resolve)

const Home = resolve => require(['./views/home/index'], resolve)
const HomeCreature = resolve => require(['./views/home/creature/index'], resolve)
const Homepage = resolve => require(['./views/home/index/index'], resolve)
const HomeShop = resolve => require(['./views/home/shop/index'], resolve)
const HomeDemo = resolve => require(['./views/home/demo/index'], resolve)
const Combat = resolve => require(['./views/combat'], resolve)
const PageNotFound = resolve => require(['./views/404'], resolve)
const PageNav = resolve => require(['./views/nav'], resolve)
const SceneHmdrPixi = resolve => require(['./views/scene/hmdr-pixi/index'], resolve)
// 低鸣猎场-01
const SceneDiMingLieChang = resolve => require(['./views/scene/diMingLieChang/index'], resolve)
// 副本
const SceneFuBen = resolve => require(['./views/scene/fuBen/index'], resolve)

export default [
  { path: '/', redirect: isMobile ? '/scene_hmdr' : '/scene_hmdr' },
  {
    path: '/',
    component: App,
    children: [
      { path: 'login', component: Login, meta: { title: '登陆注册 - heroes-online' } },
      {
        path: 'home',
        component: Home,
        meta: { title: 'heroes-online' },
        redirect: 'home/index',
        children: [
          { path: 'index', component: Homepage, meta: { title: '网站首页 - heroes-online' } },
          { path: 'creature', component: HomeCreature, meta: { title: '兵种检阅 - heroes-online' } },
          /*{path: 'shop', component: HomeShop, meta: {title: '英雄商店 - heroes-online'}},
          {path: 'demo', component: HomeDemo, meta: {title: '游客试玩 - heroes-online'}},*/
        ]
      },
      // {path: 'world', component: World, meta: {title: '大厅 - heroes-online', requireAuth: true}},
      { path: 'world', redirect: 'scene_hmdr', component: SceneHamengdaier, meta: { title: '哈蒙代尔 - heroes-online', requireAuth: true } },
      { path: 'scene_hmdr', component: SceneHamengdaier, meta: { title: '哈蒙代尔 - heroes-online', requireAuth: true } },
      { path: 'combat', component: Combat, meta: { title: '战役 - heroes-online', requireAuth: true } },
      { path: '404', component: PageNotFound, meta: { title: '页面未找到 - heroes-online' } },
      { path: 'nav', component: PageNav, meta: { title: 'heroes-online' } },
      { path: 'scene_hmdr_pixi', component: SceneHmdrPixi, meta: { title: '哈蒙代尔 - heroes-online', requireAuth: true } },
      { path: 'scene_dmlc', component: SceneDiMingLieChang, meta: { title: '低鸣猎场 - heroes-online', requireAuth: true } },
      { path: 'scene_fuben', component: SceneFuBen, meta: { title: '副本 - heroes-online', requireAuth: true } },
    ]
  },
  { path: '*', redirect: '/404' },
]
